import { fetchRequest } from 'src/hooks/useAPIRequest'

// Counters only: same structure and keys as the app in /inspection/meta (see getApplications)
export interface ItemCounters {
    key: string
    count: number
    warningCount: number
    warningDescription?: string | null
    items: ItemCounters[] | null
}

export interface ModuleCounters {
    key: string
    itemGroups: { key: string | null; items: ItemCounters[] }[]
    warningCount: number
    warningDescription: string | null
}

export interface AppCounters {
    key: string
    modules: ModuleCounters[]
}

export type ExpertCounterModule = 'trade-in' | 'manager'

const getExpertCounters = (module: ExpertCounterModule) =>
    fetchRequest<AppCounters[]>(`/inspection/meta/counters/${module}`)

export default getExpertCounters
